// import config from 'config';
import { LoginApi, UserApi, DashboardApi} from '../apis';
import {handleResponse, handleException} from './response.handler';
import { setAuthToken } from '@/auth/authCredentials';
import i18n from '@/plugins/i18n';

export const userService = {
  login,
  logout,
  getMyProfile,
  getMyDashboard
  // updateMyProfile,

  // updatePassword
};

// default export도 추가
export default userService;

function login(username, password){
  return LoginApi
    .authenticate(username, password)
    .then(success => handleResponse(success), error => handleException(error))
    .then( resp => {
      console.log('login response', resp);
      //case: 200 OK
      if(resp.status!==200){
        return Promise.reject(i18n.t('login.serviceError'));
      }

      if(resp.data?.result === 'S' ){
        // result==s ,token o -> 성공
        console.log('auth response data', resp);
        if( resp.data.content.authToken ){
          setAuthToken(resp.data.content.authToken);

          return resp.data.content.userProfile? Promise.resolve(resp.data.content.userProfile) : Promise.reject(i18n.t('login.noUserProfile'));
        } else {
          // result==s, token x -> error(예기치 못한 에러)
          return Promise.reject(i18n.t('login.serviceError'));
        }
      }
      // f token x -> resultDesc , f token o -> resultDesc
      if(resp.data?.result === 'F' ){
        console.log('auth response data', resp);
        return Promise.reject(resp.data.resultDesc?resp.data.resultDesc:i18n.t('login.serviceError'));
      }
      console.log('auth response data', resp);
      // let authResp = JSON.stringify(resp);

      //200 아니면 서버와 통신에 문제가 있는 경우 -> error로 이동
      return Promise.reject(i18n.t('login.serviceError'));
    },
    error => {
      //case : 서버에러 , resp.content.authToken: undefined
      console.log('login error', error);
      return Promise.reject(error);
    });
}

function logout(){
  localStorage.removeItem('user');
}


function getMyProfile(){
  return UserApi
    .getMyProfile()
    .then(handleResponse);
}


function getMyDashboard(){
  return DashboardApi
    .getMyDashboard()
    .then(handleResponse)
    .then( dashboard => {
      return dashboard;
    });
}

/*
function updateMyProfile(formData){
    return UserApi
        .updateMyProfile(formData)
        .then(handleResponse)
        .then( profile => {
            let user = JSON.parse(localStorage.getItem('user'));
            user.userProfile = profile;
            localStorage.setItem('user', JSON.stringify(user));
            return user;
        });
}

function updatePassword(currentPassword, updatedPassword){
    return UserApi
        .updatePassword(currentPassword, updatedPassword)
        .then(handleResponse)
        .then( content => {
            // 암호 변경 결과가 성공이면 Empty Object가 반환되므로,
            // 다른 처리를 할 것은 없다.
            return content;
        });
}
*/
